import * as actions from './actions';
import * as mutations from './mutations';
import { ScoreSetState } from './state';
import * as getters from './getters';

export const scoreSetStore = {
  namespaced: true,
  state: {
    scoreSet: {
      isLoading: false,
      data: {}
    },
    scoreSetUpdate: {
      isLoading: false
    },
    events: {
      isLoading: false
    }
  } as ScoreSetState,
  actions,
  getters,
  mutations
};
